import Client from './Client'
import { Error } from './Error'

export default class Team extends Client {
  async fetchTeam(token, payload) {
    try {
      return await this.request(token, 'get', 'profil/team', null, { offset: payload.offset, limit: payload.limit })
    } catch (error) {
      throw new Error(error)
    }
  }

  async addMember(token, email ) {
    try {
      return await this.request(token, 'post', 'profil/team', { email }, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async deleteMember(token, id ) {
    try {
      return await this.request(token, 'delete', `profil/team/${id}`, null, null)
    } catch (error) {
      throw new Error(error)
    }
  }
}
